import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { DistribuidoresContent } from "./Distribuidores.jsx";

export default function DistribuidoresModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-w-4xl w-[95vw] sm:w-[92vw] max-h-[92vh] overflow-y-auto p-0 bg-[#f7f7f4] border-[#e5e8e2] rounded-2xl"
        data-testid="distribuidores-modal"
      >
        <DialogTitle className="sr-only">Distribuidores EUZERONE</DialogTitle>
        <DialogDescription className="sr-only">
          Solicita unirte a la red de distribución EUZERONE
        </DialogDescription>
        <DistribuidoresContent variant="modal" onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
